import {
  cssClass,
  elideTextStyle,
  HorizontalFlexContainer
} from '@tableau/data-catalog-shared';
import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React = require('react');
import { Messages } from '../../../gen-src/Localize';
import { SvgCloseButton } from '../../../gen-src/icons/CloseButton';
import { lineageNavFilterIndicatorHeight } from './LineageNavStyles';

export const filterIndicatorMessageTestId = 'filter-indicator-message-test-id';
export const filterIndicatorClearButtonTestId = 'filter-indicator-clear-button-test-id';

const buttonDimensions = lineageNavFilterIndicatorHeight - TabStyles.Sizing.BorderWidth * 2;
const filterTextMaxWidth = 150;

const filteredIndicatorClass = cssClass('filteredIndicator', {
  fontSize: TabStyles.Typography.Sizing.Default,
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  border: `${TabStyles.Sizing.BorderWidth}px solid ${TabStyles.Colors.F5}`,
  boxSizing: 'border-box',
  height: lineageNavFilterIndicatorHeight,
  lineHeight: `${lineageNavFilterIndicatorHeight}px`,
  alignItems: 'center',
});

const clearButtonStyle: React.CSSProperties = {
  padding: 0,
  marginLeft: TabStyles.Spacing.MediumSpace,
  minHeight: buttonDimensions,
  minWidth: buttonDimensions,
  height: buttonDimensions, // for IE
  width: buttonDimensions // for IE
};

const filteredItemTextClass = cssClass('filteredItemText', {
  ...elideTextStyle,
  maxWidth: filterTextMaxWidth
});

export interface FilterIndicatorWithClearButtonProps {
  readonly clearFilters: () => void;
  readonly filteredItemName: string;
}

export function FilterIndicatorWithClearButton(props: FilterIndicatorWithClearButtonProps): JSX.Element | null {
  return (
    <HorizontalFlexContainer additionalClassNames={[filteredIndicatorClass]}>
      <span
        className={filteredItemTextClass}
        data-tb-test-id={filterIndicatorMessageTestId}
        title={props.filteredItemName}
      >
        {Messages.Filter({ filteredItemName: props.filteredItemName })}
      </span>
      <ButtonWidget
        buttonType={ButtonType.Icon}
        handleClick={props.clearFilters}
        title={Messages.ClearFilter()}
        testId={filterIndicatorClearButtonTestId}
        style={clearButtonStyle}
        getContent={() => { return (<SvgCloseButton />); }}
      />
    </HorizontalFlexContainer>
  );
}
